import React from 'react';
import propTypes from 'prop-types';

import VisibilitySensor from 'react-visibility-sensor';

const Video = ({ videoUrl, posterUrl, autoplay, loop }) => {
  const videoPlayer = React.useRef();

  const onChange = isVisible => {
    if (
      isVisible &&
      videoPlayer.current &&
      videoPlayer.current.played.length === 0
    ) {
      videoPlayer.current.play();
    }
  };

  return (
    <VisibilitySensor
      partialVisibility={true}
      active={autoplay}
      minTopValue={180}
      onChange={onChange}
    >
      <video
        ref={videoPlayer}
        src={videoUrl}
        playsInline={autoplay}
        poster={posterUrl}
        data-mp4={videoUrl}
        data-poster={posterUrl}
        loop={loop}
        muted={autoplay}
        controls={!autoplay}
      />
    </VisibilitySensor>
  );
};

Video.propTypes = {
  videoUrl: propTypes.string.isRequired,
  posterUrl: propTypes.string,
  autoplay: propTypes.bool,
  loop: propTypes.bool,
};

Video.defaultProps = {
  autoplay: false,
  loop: false,
};

export default Video;
